export default "__VITE_ASSET__D9l97Pzk__"